import React, {useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { forgotPasswordApi, resetPasswordApi } from "api/services/authentication";
import { toast, Bounce } from "react-toastify";
import { useSearchParams } from "react-router-dom"; // Get query params

const ResetPassword = () => {
    const navigate = useNavigate();
// Validation Schema using Yup
const schema = yup.object().shape({
    password: yup.string().min(5, "Password must be at least 5 characters").required("Password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");

    // Get email & token from URL
    useEffect(() => {
        setEmail(searchParams.get("email") || "");
        setToken(searchParams.get("token") || "");
      }, [searchParams]);

  const onSubmit =  (data) => {
    const payload = {
        email,
        token,
        password: data.password,
      };
    console.log("Forgot Password Request:", data);
    resetPasswordApi(payload).then(res=>{
      toast.success(res?.data?.message||"Password has been reset successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        navigate("/login")
    }).catch(err=>{
      console.log(err, "LLLL")
      const error = err.response?.data?.error || "Failed to reset password"
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    })
    // alert("Password reset link sent to " + data.email);
  };


  return (
    <div className="account-page">
      <div className="main-wrapper">
        
        <div className="account-content">
          <div className="container">
            <div className="account-logo">
              <Link to="/app/main/dashboard">
                <img src={"https://storage.mealtrackr.io/internal/Nandos-Logo.png"} alt="Dreamguy's Technologies" />
              </Link>
            </div>
            <div className="account-box">
              <div className="account-wrapper">
                <h3 className="account-title">Reset Password</h3>
                {/* <p className="account-subtitle">
                  Enter your email to get a password reset link
                </p> */}
                <form onSubmit={handleSubmit(onSubmit)}>
          {/* Password Field */}
          <div className="mb-3">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className={`form-control ${errors.password ? "is-invalid" : ""}`}
              placeholder="Enter new password"
              {...register("password")}
            />
            <div className="invalid-feedback">{errors.password?.message}</div>
          </div>

          {/* Confirm Password Field */}
          <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <input
              type="password"
              className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
              placeholder="Re-enter new password"
              {...register("confirmPassword")}
            />
            <div className="invalid-feedback">{errors.confirmPassword?.message}</div>
          </div>

          {/* Submit Button */}
          <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Reset Password"}
          </button>
        </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;
